module.exports = __webpack_public_path__ + "img/logo-small.72854063.png";